import cookies from 'js-cookie';

const key = 'ag-refer-friends-banner-closed';

export function setAgReferFriendsBannerClosed(value: boolean) {
  cookies.set(key, `${value}`, { path: '/', expires: 30, sameSite: 'lax' });
}

export function getAgReferFriendsBannerClosed() {
  const value = cookies.get(key);

  try {
    return value ? JSON.parse(value) : undefined;
  } catch {
    return undefined;
  }
}
